import { render, staticRenderFns } from "./CCorruption.vue?vue&type=template&id=7e8c2a7a"
import script from "./CCorruption.vue?vue&type=script&lang=js"
export * from "./CCorruption.vue?vue&type=script&lang=js"
import style0 from "./CCorruption.vue?vue&type=style&index=0&id=7e8c2a7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports